// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"baf54077","68":"1df24c0e","453":"70d4c0ee"}[chunkId] + ".chunk.js";
};